<template>
  <div class="dividends-tab">
    <div class="dividends-tab__content">
      <div class="dividends-tab__title">{{ isDocumentsUploaded ? i18n.divid_ready_to_pay() : i18n.divid_tab_finish_title() }}</div>
      <div class="dividends-tab__text_wrap">
        <div v-if="!isDocumentsUploaded" class="dividends-tab__text">
          {{ i18n.lbl_go_to_section() }}
          <span @click="goToDocuments" class="dividends-tab__docs-link">{{ i18n.lbl_documents() }}</span>
          {{ i18n.divid_tab_finish_text() }}
        </div>
      </div>
      <div v-if="isDocumentsUploaded" class="btn-wrap">
        <md-button @click="showDividends()" class="btn md-primary">{{ i18n.lbl_go_to_pay() }}</md-button>
      </div>
    </div>
  <!--  <div class="md-layout-item md-alignment-center-right">
      <md-table v-model="users" @md-selected="onSelect" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
        <md-table-toolbar>
          <div class="md-toolbar-section-start">
            <h1 class="md-title">{{ i18n.sale_payout_amount() }}: {{ payoutAmount }}	EUR</h1>
          </div>
        </md-table-toolbar>
        <md-table-empty-state md-label="No result found"/>
        <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select>
          <md-table-cell :md-label="i18n.sale_token_holder()" md-sort-by="user">{{ item.user }}</md-table-cell>
          <md-table-cell :md-label="i18n.sale_balance()" md-sort-by="balance">{{ item.balance }}</md-table-cell>
          <md-table-cell :md-label="i18n.sale_dividends()" md-sort-by="calculate">{{ calculate(item.balance) }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>-->
  </div>
</template>

<script>
  import { i18n } from '@js/i18n'
  import { commonEvents } from '@js/events/common_events'

  export default {
    name: 'dividends-tab',
    props: ['sale', 'isDocumentsUploaded'],
    data: _ => ({
      i18n,
      active: false,
      search: null,
      searched: [],
      selected: [],
      amountToPay: 0,
      payoutAmount: 10000,
      users: [
        {
          id: 1,
          user: 'example1@gmail.com',
          balance: 29
        },
        {
          id: 2,
          user: 'example2@gmail.com',
          balance: 51
        },
        {
          id: 3,
          user: 'example3@gmail.com',
          balance: 41
        },
        {
          id: 4,
          user: 'example4@gmail.com',
          balance: 65
        },
        {
          id: 5,
          user: 'example5@gmail.com',
          balance: 35
        },
        {
          id: 6,
          user: 'example6@gmail.com',
          balance: 15
        },
        {
          id: 7,
          user: 'example7@gmail.com',
          balance: 25
        },
        {
          id: 8,
          user: 'example8@gmail.com',
          balance: 18
        },
        {
          id: 9,
          user: 'example9@gmail.com',
          balance: 90
        },
        {
          id: 10,
          user: 'example10@gmail.com',
          balance: 155
        }
      ]
    }),
    methods: {
      onConfirm () {
        // this.value = 'Agreed'
      },
      onCancel () {
        // this.value = 'Disagreed'
      },
      calculate (summ) {
        return Math.round(this.payoutAmount / this.tokenAmount * summ)
      },
      onSelect (items) {
        this.selected = items
        this.amountToPay = this.selected.reduce((sum, item) => {
          return Number(sum) + Number(this.calculate(item.balance))
        }, 0)
      },
      showDividends () {
        this.$emit(commonEvents.dividendsPageStatus, true)
      },
      goToDocuments () {
        this.$emit(commonEvents.documentsLoadNeeded)
      }
    },
    created () {
      this.searched = this.users
    },
    computed: {
      tokenAmount () {
        return this.users.reduce((sum, item) => {
          return Number(sum) + Number(item.balance)
        }, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~scss/variables';
  @import '~scss/mixins';

  .dividends-tab {
    /*width: 100%;*/
    /*height: auto;*/
    padding: 50px 20px;
    background-color: rgba(203, 226, 230, 0.1);
    text-align: center;
    border: 1px dashed $col-border;
    border-radius: 5px;

    &__title {
      font-size: 20px;
      line-height: 26px;
      font-weight: 600;
    }

    &__text {
      font-size: 16px;
      line-height: 20px;
    }

    &__content {
      max-width: 380px;
      margin: auto;
    }

    &__docs-link {
      color: $col-md-primary;
      cursor: pointer;
    }
  }

  .dividends-tab__text,
  .btn-wrap {
    margin-top: 20px;
  }

  .md-content {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 6px 14px;
  }

  .md-button {
    & /deep/ .md-button-content {
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/tabs/Sales.DividendsTab.vue